import {
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	Component,
	HostBinding,
	OnInit,
	ViewEncapsulation,
} from "@angular/core";
import { Store } from "@ngrx/store";
import { LazyItem, LazyItemType } from "@obg/common.lazy-loader";
import { HomeConfigService } from "@obg/core.home";
import { CommonState } from "@obg/ngx.common";
import { JurisdictionSelector } from "@obg/ngx.core";
import { ignoreNil } from "@obg/rxjs";
import { Observable, of } from "rxjs";
import { switchMap } from "rxjs/operators";

@Component({
	selector: "obg-m-home-wrapper-container",
	templateUrl: "./home-wrapper.container.html",
	styleUrls: ["./home-wrapper.container.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class HomeWrapperContainer implements OnInit {
	@HostBinding("class.obg-m-home") hostClass = true;

	isReadyToLazyLoad$: Observable<boolean> | undefined;
	homeLazyModule: Partial<LazyItem> = {
		type: LazyItemType.module,
	};

	constructor(
		private homeConfigService: HomeConfigService,
		private store: Store<CommonState>,
		private changeDetector: ChangeDetectorRef
	) {}

	ngOnInit() {
		this.isReadyToLazyLoad$ = this.store.select(JurisdictionSelector.get).pipe(
			ignoreNil(),
			switchMap(() => {
				const isHomePageV2Enabled = this.homeConfigService.getHomePageV2Enabled();
				const isHomePageFabricEnabled = this.homeConfigService.getIsHomePageFabricEnabled();

				if (isHomePageV2Enabled && !isHomePageFabricEnabled) {
					this.homeLazyModule.name = "HomePageV2Module";
					this.homeLazyModule.path = () => import("./home-page-v2-component/home-page-v2.module");
				} else if (isHomePageFabricEnabled) {
					this.homeLazyModule.name = "HomePageFabricModule";
					this.homeLazyModule.path = () => import("./homepage-fabric/home-page-fabric.module");
				} else {
					this.homeLazyModule.name = "HomeUiModule";
					this.homeLazyModule.path = () => import("./home-component/home.module");
				}
				this.changeDetector.detectChanges();
				return of(true);
			})
		);
	}
}
